import { z } from "zod/v4";

import {
  CreateExclusionGroupDtoSchema,
  CreateExclusionGroupEntityDtoSchema,
} from "../dtos/exclusion-group";

export const CreateExclusionGroupEntityFeSchema =
  CreateExclusionGroupEntityDtoSchema.extend({
    experienceId: z.uuid().optional(),
  });
export type CreateExclusionGroupEntityFe = z.infer<
  typeof CreateExclusionGroupEntityFeSchema
>;

export const CreateExclusionGroupFeSchema =
  CreateExclusionGroupDtoSchema.extend({
    exclusionGroupEntities: CreateExclusionGroupEntityFeSchema.array().default(
      []
    ),
  });

export type CreateExclusionGroupFe = z.infer<
  typeof CreateExclusionGroupFeSchema
>;
